export default __webpack_public_path__ + "static/media/catarinabarros9.860aae17.jpg";